// @flow
import React from 'react';
import { ButtonFilterItem } from 'components/atoms/buttonFilterItem';
import type { ProjectStatusOption } from 'types/filter';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  activeFilters: Array<number>,
  toggleFilter: (option: any) => void,
  options: Array<ProjectStatusOption>,
};

export const ProjectStatusFilter = (props: Props) => {
  const { options, activeFilters = [], toggleFilter } = props;

  return (
    <div className={'project-status-filter filter'}>
      <h5 className={'filter-title'}>Project Status</h5>
      <div className={'filter-options'}>
        {options.map(option => {
          return (
            <ButtonFilterItem
              key={option.id}
              title={option.title}
              color={option.color}
              onClick={() => toggleFilter(option)}
              isActive={activeFilters.indexOf(option.id) > -1}
            />
          );
        })}
      </div>
    </div>
  );
};
